import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 group">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-xl text-primary-400"></i>
                </div>
                <span className="font-heading text-lg text-background-50 whitespace-nowrap">
                  木瓜影视
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                高清不缓冲在线观看平台，免费无广告极速播放，最新电视剧电影高清免费在线看，畅享流畅观影体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                热门推荐
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/article/article-1"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    暑期档电影推荐
                  </Link>
                </li>
                <li>
                  <Link
                    to="/article/article-2"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    古装剧国风热潮
                  </Link>
                </li>
                <li>
                  <Link
                    to="/article/article-3"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    国产动画崛起之路
                  </Link>
                </li>
                <li>
                  <Link
                    to="/article/article-4"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    纪录片观看指南
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                关于我们
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    用户口碑
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    联系我们
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-sm text-background-500">
                &copy; {new Date().getFullYear()} 木瓜影视 muguays.com 版权所有
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="#"
                  className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  服务条款
                </a>
                <a
                  href="#"
                  className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  隐私政策
                </a>
                <a
                  href="#"
                  className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  免责声明
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}